import { createContext, ReactNode, useState } from 'react'
import { initialStyle } from '../../theme/compStyleOverride'
import { ThemeOptions } from '@mui/material'
import theme from '../../theme'
import { ThemeProvider as MuiThemeProvider } from '@mui/material'
type ThemeType = {
    dateFormat:"DD-MM-YYYY" | "MM-DD-YYYY" | "YYYY-MM-DD",
    muiTheme:ThemeOptions
}
type ThemeProvideType = {
    customTheme:ThemeType,
    setCustomTheme:(params:ThemeType)=>void
}

const initial:ThemeType = {
    dateFormat:"DD-MM-YYYY",
    muiTheme:initialStyle
}

export const MainThemeContext = createContext<ThemeProvideType>({
    customTheme:initial,
    setCustomTheme:(_:ThemeType)=>{}
})
function ThemeProvider({children}:{children:ReactNode}) {
    const [customTheme,setCustomTheme] = useState<ThemeType>(initial)
  return (
    <MainThemeContext.Provider value={{customTheme,setCustomTheme}}>
      <MuiThemeProvider theme={theme(customTheme.muiTheme)}>
        {children}
      </MuiThemeProvider>
    </MainThemeContext.Provider>
  )
}

export default ThemeProvider
